import { useParams } from 'react-router'
import { useEffect, useState } from 'react';
import { getSubFromToken, validateToken } from './lib/api/externalTokenValidation';
import { getItemByCodeAndBrand } from './lib/api/item';
import { ProductExternal as ProductExternalComponent } from './components/ProductExternal'
import { getPublicProductInfoMap, getUtente, logAnalytic } from './api';
import { normalizeArticleDetails } from './helpers';
import { setProductProperties } from './actions/appActions';
import { setIsLoadingFromLocalStorage } from './actions/pageStateActions';
import { useDispatch } from 'react-redux';
import ErrorPage from './components/ErrorPage';
import { getDescrizioneArticolo } from './components/ArticleComponents/ArticleDetails/ArticleDetailsBodyUtils';
import { getCodiceArticolo } from './components/ProductExternal/utils/utils';

export const ProductExternal = () => {
    const params = useParams()
    const [loaded, setLoaded] = useState(false)
    const [token, setToken] = useState('')
    const [userAuthenticated, setUserAuthenticated] = useState(false)
    const [brandCode, setBrandCode] = useState('')
    const [productCode, setProductCode] = useState('')
    const [product, setProduct] = useState({})
    const [productDetails, setProductDetails] = useState({})
    const [user, setUser] = useState({})
    const dispatch = useDispatch()


    useEffect(async () => {
        dispatch(setIsLoadingFromLocalStorage(false))

        if(!params && !params.token) return

        setToken(params.token)
        setBrandCode(params.brand_code)
        setProductCode(params.product_code)


        // Controllo il token ricevuto
        const validated = await validateToken(params)

        setUserAuthenticated(validated)
        setLoaded(true)

    }, [params])


    useEffect(async () => {
        if(!userAuthenticated) return

        // se è valido interrogo il backend per i dati
        // console.log('ora che l\' utente è autenticato posso richiamare il prodotto')

        // se trovo il prodotto popolo lo state locale del component e visualizzo la scheda prodotto
        const productData = await getItemByCodeAndBrand({brandCode: brandCode, productCode: productCode})

        if(!productData) {
            setProduct(productData)
            return
        }

        setProduct(productData.data)

    }, [userAuthenticated])


    useEffect(async () => {
        if(Object.keys(product) < 1) return

        // Abbiamo un prodotto, allora recupero le label delle proprietà dei prodotti
        // Dichiaro per ora una funzione dentro l' useEffect
        const fetchProductInfo = async () => {
            try {
                const productInfoMapRes = await getPublicProductInfoMap();
                dispatch(setProductProperties(productInfoMapRes.data));
                dispatch(setIsLoadingFromLocalStorage(false))
            } catch (error) {
                console.error('Errore nel recupero delle proprietà prodotto', error);
            }
        };

        fetchProductInfo();

        setProductDetails(normalizeArticleDetails(product))

        let article = {}

        if (product.data && product.data.metadata.immagine_prodotto) {
            article.immagine_prodotto = product.data.metadata.immagine_prodotto;
        }


        // Prima estraggo l' id dell' utente
        const userId = getSubFromToken(token)

        // poi recupero i dati dell' utente
        const userData = await getUtente(userId)

        if(!userData) return

        // se ho recuperato l' utente, setto la variabile nello state e poi loggo
        setUser(userData.data)

    },[product])

    useEffect(() => {
        if(Object.keys(user).length === 0) return

        // Log per le statistiche
        const productCodeDecoded = getCodiceArticolo(productDetails) ? getCodiceArticolo(productDetails) : ''
        const productDescription = getDescrizioneArticolo(productDetails) ? getDescrizioneArticolo(productDetails) : ''

        const logData = {
            utente: `${user.nome} ${user.cognome}`,
            brand: brandCode,
            code: productCodeDecoded,
            subject: 'api',
            operation: 'Scheda prodotto',
            code_description: productDescription
        }

        logAnalytic(logData).then(r => console.log(r))
    }, [user])


    return (
        <>
            {(loaded && !userAuthenticated ) && (
                <ErrorPage
                    message="Non autenticato"
                    showBackButton={false}
                    showReloadButton={false}
                />
            )}

            {userAuthenticated && Object.keys(productDetails).length > 0 && (
                <ProductExternalComponent
                    product={product}
                    productDetails={productDetails}
                    />
            )}

            {!product && (
                <ErrorPage
                message="Articolo non trovato o parametri richiesta non corretti!"
                showBackButton={false}
                showReloadButton={false}
                />
            )}

        </>
    )

}